
<div class="card">
  <div class="card-header card-header-squirrel">
    <h4>{{this.translate.data['SUBTITLEGROUPROLEPERMISSIONS'] | translate}}</h4>
    <h4>{{groupRole.name}}</h4>
  </div>
  <div class="card-body">
    <project-permissions-list [permissions]="groupRole.permissions" (onChangeEvent)="onChange1($event)"></project-permissions-list>

    <div class="row button-right">
      <!-- <button matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}" mat-button  (click)="cancel()">
          <mat-icon>close</mat-icon>
      </button>
      <span style="flex: 1 1 auto"></span> -->
      <a>
        <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                        (click)="cancel()" >Schließen</button>
      </a>                   
      <!-- <span style="flex: 1 1 auto"></span> -->
</div>       

  </div>
</div>

